module.exports = __webpack_public_path__ + "img/table-export-orange.856f0a3a.svg";